<img *ngIf="image" [src]="imageUrl" [alt]="image.alt" [style.objectPosition]="objectPosition" />
